import { CreateMixin } from "@pdfking/reactivity/preact"
import proxy from "@pdfking/workflow/utils/proxy"
import { dismiss_dropdowns } from "../core/bootstrap"
import toggle_class from "../dom/toggle_class"
import navigate from "../routes/navigate"
import keyboard from "../state/keyboard"

export const CloseMixin = CreateMixin({
  computed: proxy(keyboard(), { ESCAPE: "escape_pressed" } as const),
  data: {
    toggled_class: "" as string,
  },
  methods: {
    close() {
      navigate()
    },
  },
  mounted() {
    toggle_class(document.body, { [this.toggled_class]: true })
  },
  unmounted() {
    toggle_class(document.body, { [this.toggled_class]: false })
  },
  watch: {
    escape_pressed() {
      dismiss_dropdowns()
      this.close()
    },
  },
})
